<template>
  <el-dialog
    custom-class="theme__dialog"
    width="360px"
    title="主题设置"
    append-to-body
    v-drag
    :visible.sync="visible"
    :close-on-click-modal="false"
    @open="getTheme">
    <div class="system-line" v-if="showSystem">
      <div class="title">系统名称：</div>
      <div class="system-name-contral">
        <el-input v-model="systemName" />
        <el-button type="text" @click="handleSave">保存</el-button>
        <el-button type="text" @click="handleReset">重置</el-button>
      </div>
    </div>
    <div class="theme__dialog__headercolor">
      <div>
        <span class="theme__dialog__title">对比度：</span>
        <el-slider
          v-model="svgFilter"
          :show-tooltip="false"
          :min="1"
          :max="3"
          :step="0.5"
          @change="svgFilterChange">
        </el-slider>
      </div>
      <div>
        <span class="theme__dialog__title">导航栏背景：</span>
        <span
          v-for="color in headerColors"
          :key="color"
          class="theme__dialog__item"
          :style="{borderColor: color, backgroundColor: headerColor === color ? color: ''}"
          @click="headerColorChange(color)">
        </span>
      </div>
    </div>
    <div>
      <span>导航栏主题：</span>
      <el-radio-group v-model="menuTheme" @change="saveTheme">
        <el-radio label="light">浅色</el-radio>
        <el-radio label="dark">深色</el-radio>
      </el-radio-group>
    </div>
  </el-dialog>
</template>

<script>
  import { HEADER_BG_GRADIENT } from '../layout/conf'
  import { createWatermarkStyle } from 'public/utils'

  const HEADER_COLORS = Object.keys(HEADER_BG_GRADIENT)

  export default {
    name: 'theme',
    data () {
      return {
        visible: false,
        systemName: '',
        headerColors: HEADER_COLORS,
        headerColor: HEADER_COLORS[0],
        menuTheme: 'light',
        svgFilter: +localStorage.svgFilter || 1,
      }
    },
    computed: {
      showSystem () {
        let permission = this.$store.state.permission.menus
        return permission && permission.includes('BToQFWiq5iP-')
      }
    },
    mounted () {
      this.getTheme(true)
      this.svgFilterChange(this.svgFilter)
    },
    methods: {
      headerColorChange (color) {
        this.headerColor = color
        this.saveTheme('header')
      },
      saveTheme (val) {
        const header = this.headerColor
        const obj = {
          header,
          menu: this.menuTheme,
          headerGradient: HEADER_BG_GRADIENT[header]
        }
        localStorage.ERPTHEME = JSON.stringify(obj)
        this.$bus.$emit('SET_THEME', obj, val === 'header' ? val : 'menu')
      },
      handleSave () {
        localStorage.GLOABL_ERP_SYSTEM_NAME = this.systemName
        this.$bus.$emit('SET_SYSTEM_NAME')
      },
      handleReset () {
        this.systemName = ''
        localStorage.GLOABL_ERP_SYSTEM_NAME = ''
        this.$bus.$emit('SET_SYSTEM_NAME')
      },
      getTheme (init) {
        try {
          const obj = JSON.parse(localStorage.ERPTHEME || '{}')
          if (obj && obj.header && obj.menu && obj.headerGradient) {
            this.headerColor = obj.header
            this.menuTheme = obj.menu
            if (init) {
              this.$bus.$emit('SET_THEME', obj)
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
      svgFilterChange (e) {
        localStorage.svgFilter = e
        const doms = document.querySelectorAll('.hc_extension_rgb')
        const reverseDoms = document.querySelectorAll('.hc_extension_reverse_rgb')
        if (doms && doms.length) {
          doms.forEach(v => v.setAttribute('exponent', e))
        }
        if (reverseDoms && reverseDoms.length) {
          // 取倒数，反转对比度
          reverseDoms.forEach(v => v.setAttribute('exponent', (1 / e).toFixed(2)))
        }
        document.documentElement.setAttribute('hc', e)
        if (window.__ERPUSER__ && window.__ERPUSER__.name) {
          createWatermarkStyle(window.__ERPUSER__, e)
        }
      }
    }
  }
</script>

<style lang="scss">
  .theme__dialog {
    .el-dialog__body {
      padding: 40px 16px;
    }
    &__headercolor {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #c1bfc7;
      padding-bottom: 26px;
      margin-bottom: 26px;
      > div {
        display: flex;
        align-items: center;
        &:first-child {
          margin-bottom: 26px;
        }
        > div.el-slider {
          float: right;
          width: 80%;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
    }
    &__title {
      width: 85px;
      text-align: right;
    }
    &__item {
      width: 26px;
      height: 26px;
      border-radius: 16px;
      margin-right: 16px;
      border: 2px solid;
      cursor: pointer;
    }

    .system-line {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      text-align: right;
      .title {
        width: 85px;
      }
      .system-name-contral {
        display: flex;
        align-items: center;
        .el-button {
          margin-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/theme.vue